
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiDiodes04On as ObiDiodes04OnElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-diodes-04-on.js';
 
 
 

 
 export const ObiDiodes04On = createComponent({
   react: React,
   tagName: 'obi-diodes-04-on',
   elementClass: ObiDiodes04OnElement,
   events: {
     
   }
  });
 
 